module.exports = __webpack_public_path__ + "static/media/card_villa.e3ffca57.jpg";